export function ValidDate(dateString) {
  if (dateString === null || dateString === undefined || dateString === "") {
    return null;
  }

  const raw = String(dateString).trim();
  if (!raw) return null;

  const pad2 = (n) => String(n).padStart(2, "0");

  const isValidDateParts = (y, m, d) => {
    if (!y || !m || !d) return false;
    if (m < 1 || m > 12) return false;
    if (d < 1 || d > 31) return false;
    const test = new Date(y, m - 1, d);
    return (
      !isNaN(test.getTime()) &&
      test.getFullYear() === y &&
      test.getMonth() === m - 1 &&
      test.getDate() === d
    );
  };

  // ISO date (YYYY-MM-DD)
  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) return raw;

  // ISO datetime or any JS-parsable date string
  const parsed = new Date(raw);
  if (!isNaN(parsed.getTime())) {
    return parsed.toISOString().split("T")[0];
  }

  // Handle common "DD-MM-YYYY", "MM-DD-YYYY", "DD/MM/YYYY", "MM/DD/YYYY"
  const m = raw.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})$/);  // Updated regex here
  if (m) {
    const p1 = Number(m[1]);
    const p2 = Number(m[2]);
    const y = Number(m[3]);

    // Decide whether it's DD-MM-YYYY or MM-DD-YYYY
    let day;
    let month;

    if (p1 > 12 && p2 <= 12) {
      // 19-01-2025 => DD-MM-YYYY
      day = p1;
      month = p2;
    } else if (p2 > 12 && p1 <= 12) {
      // 01-19-2025 => MM-DD-YYYY
      month = p1;
      day = p2;
    } else {
      // Ambiguous (both <= 12): prefer DD-MM-YYYY (common for +91)
      day = p1;
      month = p2;
    }

    if (isValidDateParts(y, month, day)) {
      return `${y}-${pad2(month)}-${pad2(day)}`;
    }

    // Fallback to the other interpretation if the first was invalid
    const altDay = p2;
    const altMonth = p1;
    if (isValidDateParts(y, altMonth, altDay)) {
      return `${y}-${pad2(altMonth)}-${pad2(altDay)}`;
    }
  }

  return null;
}


export function ConversionValidDate(dateString) {
  if (!dateString) return null; // Handle empty or undefined values

  // Try parsing using Date constructor (ISO 8601 format: '2000-01-19T18:30:00.000Z')
  const parsedDate = new Date(dateString);
  if (!isNaN(parsedDate.getTime())) {
    return formatToMMDDYYYY(parsedDate);
  }

  // Check for "MM-DD-YYYY" / "DD-MM-YYYY" (and with /)
  const regex = /^(\d{1,2})[-/](\d{1,2})[-/](\d{4})$/;  // Updated regex here
  const match = String(dateString).trim().match(regex);
  if (match) {
    const p1 = Number(match[1]);
    const p2 = Number(match[2]);
    const year = match[3];

    // Prefer returning MM-DD-YYYY, so decide which part is month
    let month = p1;
    let day = p2;

    if (p1 > 12 && p2 <= 12) {
      // DD-MM-YYYY -> swap
      month = p2;
      day = p1;
    }

    return `${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}-${year}`;
  }

  // If none of the above formats work, return null
  console.error("Invalid date format:", dateString);
  return null;
}

// Helper function to format a Date object to MM-DD-YYYY
function formatToMMDDYYYY(dateObj) {
  const month = String(dateObj.getMonth() + 1).padStart(2, "0"); // Get month (0-based index)
  const day = String(dateObj.getDate()).padStart(2, "0"); // Get day
  const year = dateObj.getFullYear(); // Get year
  return `${month}-${day}-${year}`; // Format as MM-DD-YYYY
}
